import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Card,
    CardBody,
    Container,
} from "reactstrap";

import CommonTable from "../../../components/Common/TableContainer";
import ScheduleAddEditModal from "pages/AllCommonModal/ScheduleAddEditModal/schedule-add-edit-modal";
import TodayAddEditModal from "pages/AllCommonModal/TodayAddEditModal/today-add-edit-modal";
import WrongNumberAddEditModal from "pages/AllCommonModal/WrongNumberAddEditModal/wrong-number-add-edit-modal";
import InprogressAddEditModal from "pages/AllCommonModal/InProgressAddEditModal/in-progress-add-edit-modal";


const InProgress = () => {

    const [searchQuery] = useState("");
    const [inProgressAddEditModalOpen, setInProgeressAddEditModalOpen] = useState(false);
    const columns = [
        { Header: "Name", accessor: "name" },
        { Header: "Client", accessor: "client" },
        { Header: "Phone", accessor: "phone" },
        { Header: "Date Added", accessor: "date_added" },
        { Header: "Post Applied", accessor: "post_applied" },
        { Header: "Status", accessor: "status" },
        { Header: "Last Call Date Time", accessor: "last_call_date_time" },
    ];

    const jobCategoryData = [
        { name: "Avijit Adak", candidate: "Rovert Allen",  phone: "(256) 3467 890", date_added: "25-08-2025", post_applied: "", status: "active", last_call_date_time: "15-12-2025",  },
        { name: "Tony Lockhart", candidate: "Rovert Allen",  phone: "(256) 3467 899", date_added: "12-08-2025", post_applied: "", status: "active", last_call_date_time: "24-12-2025",  },
    ];

    // Filtering only when search button is pressed
    const filteredData = useMemo(() => {
        if (!searchQuery.trim()) return jobCategoryData;

        return jobCategoryData.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery]);

    const handleEdit = (row) => {
        setInProgeressAddEditModalOpen(true)
      };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <CommonTable columns={columns} data={filteredData} isActionRequired={false} onEdit={handleEdit}  />
                        </CardBody>
                    </Card>
                    <InprogressAddEditModal inProgressAddEditModalOpen={inProgressAddEditModalOpen} setInProgeressAddEditModalOpen={setInProgeressAddEditModalOpen}/>

                </Container>
            </div>
        </React.Fragment>
    );
};

InProgress.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(InProgress);
